// extracted by mini-css-extract-plugin
export default {"detail-info-popover":"detail-info-popover","deleteImage":"deleteImage","arrow":"arrow"};